import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";

const Radio = forwardRef(
  ({ label, id, name, value, checked, onChange, className, ...props }, ref) => {

    return (
      <span className={clsx("tw-flex tw-items-center", className)}>
        <input
          type="radio"
          ref={ref}
          id={id}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          {...props}
          className="tw-h-4 tw-w-4 tw-border-solid tw-border-brand-blue-darker tw-text-brand-blue-darker focus:tw-ring-brand-blue-darker"
        />
        <label
          htmlFor={id}
          className="tw-ml-2 tw-block tw-text-sm tw-font-medium tw-leading-6 tw-text-gray-900"
        >
          {label}
        </label>
      </span>
    );
  }
);

Radio.propTypes = {
  /** The label displayed next to the radio button */
  label: PropTypes.string.isRequired,
  /** The id attribute of the input element */
  id: PropTypes.string.isRequired,
  /** The name attribute of the input element */
  name: PropTypes.string,
  /** The value attribute of the input element */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Whether the radio button is checked */
  checked: PropTypes.bool,
  /** Function to call on input change */
  onChange: PropTypes.func,
};

export default Radio;
